import { IModel } from './modelType'

export enum LanguageCode {
  en_UK = 'en_UK',
  en_US = 'en_US',
  en_CA = 'en_CA',
  en_AU = 'en_AU',
  nl_NL = 'nl_NL',
  fr_FR = 'fr_FR',
  fr_CA = 'fr_CA',
  th_TH = 'th_TH',
  de_DE = 'de_DE',
  zh_CN = 'zh_CN',
  ja_JP = 'ja_JP',
  es_MX = 'es_MX',
  es_ES = 'es_ES',
  lv_LV = 'lv_LV',
  no_NO = 'no_NO',
  pt_BR = 'pt_BR',
  pt_PT = 'pt_PT',
}

export enum Currency {
  AUD = 'AUD',
  CHF = 'CHF',
  DKK = 'DKK',
  SEK = 'SEK',
  ZAR = 'ZAR',
  EUR = 'EUR',
  THB = 'THB',
  USD = 'USD',
  CAD = 'CAD',
  GBP = 'GBP',
  MXN = 'MXN',
  CNY = 'CNY',
  SGD = 'SGD',
  NOK = 'NOK',
  BRL = 'BRL',
  JPY = 'JPY',
}

export type ProductPackage = {
  id: string
  no: string
  meta: string
}

export type ProductPackageInput = {
  id?: string
  meta?: string
  no?: string
  title?: TextInput
  productIds?: [string]
}

export type Shop = {
  id: string
  name: string
  defaultLanguage: LanguageCode
  defaultCurrency: Currency
  languages: LanguageCode[]
  variants: {
    edges: {
      node: Variant
    }[]
  }
  productPackages: {
    edges: {
      node: ProductPackage
    }[]
  }
}

export enum ProductStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum VariantType {
  COLOR = 'COLOR',
  MATERIAL = 'MATERIAL',
  MESH = 'GENDER',
}

export type TextContentInput = {
  langCode: LanguageCode
  content: string
}

export type TextInput = {
  id: string
  text: [TextContentInput]
}

export type PriceInput = {
  roundUp: boolean
  currency: Currency
  value: number
}

export type VariantOption = {
  id: string
  sortOrder: number
  value: string
  title: TextInput
}

export type Variant = {
  id: string
  sortOrder: number
  no: string
  type: VariantType
  title: TextInput
  options: VariantOption[]
}

export type VariantOptionInput = {
  id?: string
  sortOrder?: number
  value?: string
  title?: TextInput
  priceChange?: PriceInput
}

export type VariantInput = {
  id?: string
  sortOrder?: number
  no?: string
  type?: VariantType
  title?: TextInput
  options?: [VariantOptionInput]
}

export type ProductVariant = {
  id: string
  variantId: string
  options: [string]
}

export type Price = {
  roundUp: boolean
  currency: string
  value: number
  includesTax: boolean
  taxPercent: number
}

export type ProductModifier = {
  id: string
  type: string
  stringModifier: string
  priceChange: Price
}

export type ProductOptionValue = {
  id: string
  isEnabled: boolean
  accountingId: string
  variantIds: [string]
  optionValueIds: [string]
  optionValues: string
  modifiers: ProductModifier[]
}

export type Product = {
  id: string
  variants: ProductVariant[]
  optionValues: ProductOptionValue[]
}

export enum OrderType {
  REGULAR = 'REGULAR',
  SAMPLE = 'SAMPLE',
  STOCK = 'STOCK',
}
